import { useState, useEffect } from "react";

const Cell = ({ v, l }) => (
  <div className="flex flex-col items-center">
    <span className="font-display text-xl leading-none tabular-nums">
      {String(v).padStart(2, "0")}
    </span>
    <span className="text-[9px] tracking-[0.2em] text-muted-foreground">{l}</span>
  </div>
);

export const Countdown = ({ kickoff }) => {
  const target = new Date(kickoff).getTime();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = target - now;

  if (diff <= 0) {
    return (
      <div
        data-testid="countdown"
        className="px-4 py-2 border-t border-border bg-secondary/40 text-[11px] uppercase tracking-[0.2em] text-accent font-bold flex items-center gap-2"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-accent live-dot" /> Kicking off soon
      </div>
    );
  }

  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  return (
    <div
      data-testid="countdown"
      className="px-4 py-2 border-t border-border bg-secondary/40 flex items-center"
    >
      <span className="label-caps">Kickoff In</span>
      <div className="flex items-center gap-3 ml-auto">
        {d > 0 && <Cell v={d} l="DAYS" />}
        <Cell v={h} l="HRS" />
        <Cell v={m} l="MIN" />
        <Cell v={s} l="SEC" />
      </div>
    </div>
  );
};
